import React, {Component} from 'react';
import '../css/DesignPage.css';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {COLORS} from '../constants';
import {HomePage as hps} from '../strings';
import {Button as bs} from '../strings';
import ContactForm from './ContactForm';
import Button from './Button';
import {getLang, getUsers} from '../selectors';
import {fetchUsers} from '../actions';


class DesignPage extends Component {

  static defaultProps = {
    lang: 'en',
  }

  componentWillMount() {
    //const {fetchUsers} = this.props;

    //fetchUsers();
  }

  componentDidMount() {
    window.scrollTo(0,0);
  }

  render() {
    const {
      lang,
    } = this.props;

    const copy0 = 'Clases de'
    const items = [
      {name: 'Ingles', className: 'english'},
      {name: 'Software', className: 'software'},
      {name: 'Tecnologia', className: 'technology'},
      //{name: 'Espanol', className: 'spanish'},
      //{name: 'Mas', className: 'more'},
    ]

    return(
      <div className='design-page'>
        <div className='design-page-left'>

          <div className='box-container'>
            <div className='lines-container'>
              {/* <div className='top-line'>
                {copy0}
              </div> */}
              <div className='items-container'>
                {items.map((item, index) => (
                  <div key={index} className={`item ${item.className}`}>
                    {item.name.split('').map((char, index2) => (
                      <div key={index2} className='item-char'>{char}</div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className='design-page-left'>
          
        </div>

      </div>
    )
  }
}

const maxWidth = '600px';

const mapStateToProps = (state, ownProps) => {
  return {
    lang: getLang(state),
    users: getUsers(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchUsers: (params) => dispatch(fetchUsers(params)),
  }
}


const Connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(DesignPage)

export default withRouter(Connected);



// WEBPACK FOOTER //
// ./src/main/DesignPage.js